import { __rest } from "tslib";
import i18next from "i18next";
export function configureI18n(options) {
    const { defaultNS = false, lng = "en-US", fallbackLng = false, // we do not use the fallback language
    debug = false, appendNamespaceToCIMode = true, initImmediate = true, keySeparator = ".", nsSeparator = ":", pluralSeparator = "_", contextSeparator = "_", interpolation = { escapeValue: false }, react = { useSuspense: true } } = options, rest = __rest(options, ["defaultNS", "lng", "fallbackLng", "debug", "appendNamespaceToCIMode", "initImmediate", "keySeparator", "nsSeparator", "pluralSeparator", "contextSeparator", "interpolation", "react"]);
    return i18next.createInstance(Object.assign({ appendNamespaceToCIMode,
        defaultNS, // default namespace if namespace is omitted for translation key
        lng,
        fallbackLng, // fallback language if language detected in browser does not exist
        debug,
        keySeparator,
        nsSeparator,
        pluralSeparator,
        contextSeparator,
        interpolation,
        react,
        initImmediate }, rest));
}
/**
 * Initialize the translations, should be called once
 */
export function initializeI18n(options, modules = []) {
    const i18n = configureI18n(options);
    for (const module of modules) {
        i18n.use(module);
    }
    i18n.init();
    return i18n;
}
//# sourceMappingURL=initializeI18n.js.map